import { PlusButton } from "@components/buttons/plus";
import { SHContainer, SHStack, SHTypography } from "@components/design-systems";
import { PageRoutes } from "@constants";
import { useInvestment } from "@hooks/useInvestment";
import { TopBar, TopBarContainer } from "@layouts/top-bar";
import { generatePath, useNavigate } from "react-router";
import { useUserPermissions } from "@hooks/userUserPermission";

export const ManagedAccountListView = (): JSX.Element => {
  const navigate = useNavigate();
  const { isAdviserGroup } = useUserPermissions();

  const { resetStore } = useInvestment();
  const renderNewAnalysisButton = () => {
    if (isAdviserGroup) return null;

    return (
      <PlusButton
        variant="contained"
        size="extraMedium"
        onClick={() => {
          resetStore();
          navigate(
            generatePath(PageRoutes.managedAccountsDetail, {
              managedAccountId: "new",
            }),
          );
        }}
      >
        New analysis
      </PlusButton>
    );
  };
  const renderAnalysisTextContent = () => {
    if (isAdviserGroup) {
      return (
        <>
          <SHTypography variant="subtitle1">
            Exciting News: More SMA Analysis is Coming Soon!
          </SHTypography>
          <SHTypography variant="body2">
            We are building new tools for you to analyse individual models and
            portfolios of models.
          </SHTypography>
          <SHTypography variant="body2">
            If you would like to be among the first to trial this capability,
            please get in touch with us on Support@SuitabilityHub.com. Your
            feedback is invaluable, and will help us refine this feature to best
            meet your business needs.{" "}
          </SHTypography>
          <SHStack>
            <SHTypography variant="body2">
              Thank you for your continued support,
            </SHTypography>
            <SHTypography variant="body2">The SuitabilityHub Team</SHTypography>
          </SHStack>
        </>
      );
    }

    return (
      <>
        <SHTypography variant="subtitle1">
          Exciting News: SMA Analysis is Coming Soon!
        </SHTypography>
        <SHTypography variant="body2">
          We're thrilled to introduce the prototype of our Portfolio Fee
          Analysis feature as part of SMA Analysis Phase 1. You can be one of
          the first to trial this new capability by clicking the “New Analysis”
          button at the top right of this page.
        </SHTypography>
        <SHTypography variant="body2">
          Your feedback is invaluable to us. Please share your thoughts and
          suggestions by reaching out to Support@SuitabilityHub.com. Together,
          we can refine this feature to best meet your business needs.
        </SHTypography>
        <SHStack>
          <SHTypography variant="body2">
            Thank you for your continued support,
          </SHTypography>
          <SHTypography variant="body2">The SuitabilityHub Team</SHTypography>
        </SHStack>
      </>
    );
  };

  return (
    <>
      <TopBarContainer>
        <TopBar
          title={"Managed account analysis"}
          tools={renderNewAnalysisButton()}
        />
      </TopBarContainer>
      <SHContainer maxWidth={"lg"} sx={{ px: { xs: "16px", lg2: 0 } }}>
        <SHStack spacing={2}>{renderAnalysisTextContent()}</SHStack>
      </SHContainer>
    </>
  );
};
